import { render, staticRenderFns } from "./IdeaAccessChooser.vue?vue&type=template&id=c86effaa&scoped=true"
import script from "./IdeaAccessChooser.vue?vue&type=script&lang=js"
export * from "./IdeaAccessChooser.vue?vue&type=script&lang=js"
import style0 from "./IdeaAccessChooser.vue?vue&type=style&index=0&id=c86effaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86effaa",
  null
  
)

export default component.exports